import { render, staticRenderFns } from "./u-sitemap-line.vue?vue&type=template&id=952f8684&scoped=true"
import script from "./u-sitemap-line.vue?vue&type=script&lang=js"
export * from "./u-sitemap-line.vue?vue&type=script&lang=js"
import style0 from "./u-sitemap-line.vue?vue&type=style&index=0&id=952f8684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952f8684",
  null
  
)

export default component.exports